import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const GuestList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  padding-bottom: ${space['space-400']};
`;
